import styled, { css } from 'styled-components';
import { theme, media } from 'styles';

/*
  Use even numbers for height and lineWeight
  in order to avoid sub-pixel rendering.
*/
const height = 14;
const width = 21;
const color = theme.colors.black;
const lineWeight = 2;
const transitionSpeed = '0.4s';
const transitionDelay = '0s';
const easing = 'cubic-bezier(0.600, -0.280, 0.735, 0.045)';
const transition = `all ${transitionSpeed} ${easing} ${transitionDelay}`;

// prettier-ignore
export default styled.button`
  display: inline-block;
  position: relative;
  margin-right: 24px;
  transition: ${transition};
  width: ${width}px;
  height: ${height}px;
  border-top: ${lineWeight}px solid ${color};
  border-bottom: ${lineWeight}px solid ${color};

  &:after {
    transition: ${transition};
    position: absolute;
    top: ${(height - lineWeight) / 2 - lineWeight}px;
    left: 0;
    width: 100%;
    height: ${lineWeight}px;
    background-color: ${color};
    content: '';
  }

  ${media.ldesktop`display: none;`};


  ${props => props.isOpen && css`
    border-bottom: ${lineWeight}px solid transparent;
    transform: rotate(45deg) translate(0, 8px);
    &:after {
      top: -${lineWeight}px;
      transform: rotate(-90deg);
    }
  `}
`;



// WEBPACK FOOTER //
// ./src/components/shared/TopBar/components/Burger.jsx